/* Dependencies */
import styled, { css } from 'styled-components';
import { ReactComponent as ArrowIcon } from 'images/icons/sortingArrowDown.svg';

const sortedArrowStyles = css`
  transform: rotate(180deg);
`;

const sortedTooltipItemStyles = css`
  background-color: #e5f2fb;
  color: ${({ theme }) => theme.colors.darkGray};
`;

interface IProps {
  sorted?: Boolean;
}

export const TooltipContainer = styled.div<IProps>`
  cursor: pointer;
  .ContenTooltip {
    padding: 0;
  }
`;
TooltipContainer.displayName = 'SettingsTooltipSortContainer';

export const Arrow = styled(ArrowIcon)<IProps>`
  width: 14px;
  height: 10px;
  margin-left: 20px;
  transition-duration: 0.5s;

  &:hover {
    cursor: pointer;
  }
  ${({ sorted }) => sorted && sortedArrowStyles}
`;
Arrow.displayName = 'SettingsTooltipSortArrow';

export const TooltipContent = styled.div<IProps>`
  background-color: ${({ theme }) => theme.colors.white};
`;
TooltipContent.displayName = 'SettingsTooltipSortContent';

export const TooltipItem = styled.div<IProps>`
  height: 32px;
  width: 157px;
  display: flex;
  padding: 10px;
  align-items: center;
  background-color: transparent;
  color: ${({ theme }) => theme.colors.shadeDark};
  ${({ sorted }) => sorted && sortedTooltipItemStyles}
`;

TooltipItem.displayName = 'SettingsTooltipSortContentItem';
